import { useTranslation } from 'react-i18next'
import { formatPercent } from '../../i18n/format'
import React from 'react'
import OneLineContent from '../../containers/RenderStroyComponent/OneLineContent'

interface IQuizResultProps {
  quizResult?: any
  quizDetail: any
  selected: any
  story: any
  user_auth_token: any
  skritter_token: any
  chineseWordFontSize: any
  storyId: string
  optionsContent: any[]
  activeIndex: string
  handleClickWord: any
}

const checkIcon = <i className='fa fa-check color-primary' />

const QuizResult: React.FC<IQuizResultProps> = ({
  quizResult,
  selected,
  quizDetail,
  story,
  chineseWordFontSize,
  activeIndex,
  handleClickWord,
}) => {
  const { selectedAnswer, rightAnswer } = selected
  const sumSelected = quizResult.options.reduce((sum, curr) => sum + curr)
  const percentOption = quizResult.options.map((val) => Math.round((val / sumSelected) * 100))
  const { t } = useTranslation('quiz')
  const isAnswer = (val) => val == selectedAnswer
  const isRight = (val) => val == rightAnswer

  return (
    <>
      <div className='w-row section-story-content'>
        <div className='w-col w-col-9 content-left'>
          <div className='session-title'>
            <span>
              <div className='word_wrapper'>
                {quizDetail?.quizContent?.map((wordObj, index) => (
                  <OneLineContent
                    key={index}
                    WIndex={index}
                    iterator={'QUIZ-RESULT-TITLE'}
                    isFontBold={true}
                    chineseWordFontSize={chineseWordFontSize}
                    wordObj={wordObj}
                    contentDetail={quizDetail?.quizContent || []}
                    story={story}
                    showPinYin={true}
                    activeIndex={activeIndex}
                    handleClickWord={handleClickWord}
                  />
                ))}
              </div>
            </span>
          </div>
          <div className='quiz-answers'>
            <div className='form-quiz-answers'>
              {(quizDetail.options || []).map((option, iterator) => {
                const _isAnswer = isAnswer(option.value)
                const _isRight = isRight(option.value)
                let _progressClass = ''
                if (_isAnswer) {
                  _progressClass = _isRight ? `progress-percent-right` : `progress-percent-wrong`
                }
                return (
                  <div className='form-item' key={iterator}>
                    <div className='m-flx m-al-c'>
                      <div className='m-radio'>
                        {_isAnswer ? (
                          _isRight ? (
                            <i className='fa fa-check-circle color-primary' />
                          ) : (
                            <i className='fa fa-times-circle color-error' />
                          )
                        ) : (
                          <i className='fa fa-circle-o' />
                        )}
                      </div>
                      <span
                        style={{
                          fontSize: chineseWordFontSize?.newWordsExample,
                          lineHeight: '1.5',
                          letterSpacing: '1.5px',
                        }}
                      >
                        <div className='word_wrapper'>
                          {quizDetail.optionsWithContent[iterator]?.opContect?.map((wordObj, index) => (
                            <OneLineContent
                              key={index}
                              WIndex={index}
                              iterator={`QUIZ-RESULT-OPTION-${iterator}`}
                              wordObj={wordObj}
                              contentDetail={quizDetail.optionsWithContent[iterator]?.opContect || []}
                              story={story}
                              showPinYin={true}
                              activeIndex={activeIndex}
                              handleClickWord={handleClickWord}
                            />
                          ))}
                        </div>
                      </span>
                      {_isAnswer && (
                        <span className={`quiz-result-answer color-${_isRight ? 'primary' : 'default'}`}>
                          {t('result.yourAnswer')} {_isRight && checkIcon}
                        </span>
                      )}
                      {!_isAnswer && _isRight && (
                        <span className={`quiz-result-answer color-default`}>
                          {t('result.correctAnswer')} {_isRight && checkIcon}
                        </span>
                      )}
                    </div>
                    <div className={'answer-progress w-row m-al-c'}>
                      <div className={'w-col w-col-6  w-col-small-12 progress-full '}>
                        <div
                          className={`progress-percent ${_progressClass}`}
                          style={{ width: `${percentOption[iterator]}%` }}
                        />
                      </div>
                      <div className={'w-col w-col-6 w-col-small-12 m-al-l'}>
                        <span className={'progress-pos-text'}>
                          {t('result.share', { percent: formatPercent((percentOption[iterator] || 0) / 100) })}
                        </span>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default React.memo(QuizResult)
